import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { trackPageView } from "../utils/pageViewTelemetry";

/**
 * Sends one page-view beacon per route change. Renders nothing; must sit inside
 * the Router. Keyed on pathname only, so in-page fragment changes (e.g. the
 * Project Fair chapter picker) are not counted as new pages.
 */
const PageViewTracker = () => {
  const location = useLocation();
  const firstView = useRef(true);

  useEffect(() => {
    trackPageView(location, firstView.current);
    firstView.current = false;
  }, [location.pathname]);

  return null;
};

export default PageViewTracker;
